import { combineReducers } from 'redux';
import { AccountCollectionReducer } from './AccountCollection';
import { AccountCollectionNftsReducer } from './AccountCollectionNfts';
import { AccountCreatorReducer } from './AccountCreator';
import { AccountNftsReducer } from './AccountNft';
import { BlockchainNftReducer } from './BlockchainNfts';
import { CartReducer } from './Cart';
import { CategoriesReducer } from './Categories';
import { CollectionNftsReducer } from './CollectionNfts';
import { CollectionRankingsReducer } from './CollectionRankings';
import { CollectionsReducer } from './Collections';
import { CollectionStatsReducer } from './CollectionStats';
import { CompanyReducer } from './Company';
import { CreatorReducer } from './Creator';
import { CreatorCollectionsReducer } from './CreatorCollections';
import { CreatorNftsReducer } from './CreatorNfts';
import { CreatorsStatsReducer } from './CreatorsStats';
import { CurrenciesReducer } from './Currencies';
import { FeaturedCollectionsReducer } from './FeaturedCollections';
import { FilterCollectionsReducer } from './FilterCollections';
import { LayoutSettingsReducer } from './LayoutSettings';
import { MerchandiseReducer } from './Merchandise';
import { NftsReducer } from './Nft';
import { NftPropertiesRarityReducer } from './NftPropertiesRarity';
import { OmniSearchNftsReducer } from './OmniSearchNfts';
import { TransactionReducer } from './Transactions';
import { userReducer } from './User';
import { WalletReducer } from './Wallet';
import { WalletBalanceReducer } from './WalletBalance';
import { GlobalReducer } from 'appRedux/reducers/Global';

export const createRootReducer = () =>
  combineReducers({
    global: GlobalReducer,
    accountCollection: AccountCollectionReducer,
    collections: CollectionsReducer,
    collectionRankings: CollectionRankingsReducer,
    filterCollections: FilterCollectionsReducer,
    wallet: WalletReducer,
    user: userReducer,
    creator: CreatorReducer,
    company: CompanyReducer,
    creatorNfts: CreatorNftsReducer,
    creatorCollections: CreatorCollectionsReducer,
    accountNfts: AccountNftsReducer,
    nfts: NftsReducer,
    collectionNfts: CollectionNftsReducer,
    categories: CategoriesReducer,
    transactions: TransactionReducer,
    layoutSetting: LayoutSettingsReducer,
    collectionStats: CollectionStatsReducer,
    walletBalance: WalletBalanceReducer,
    creatorStats: CreatorsStatsReducer,
    accountCreator: AccountCreatorReducer,
    currencies: CurrenciesReducer,
    accountCollectionNfts: AccountCollectionNftsReducer,
    nftPropertiesRarity: NftPropertiesRarityReducer,
    blockchainNfts: BlockchainNftReducer,
    cart: CartReducer,
    merchandise: MerchandiseReducer,
    omniSearchNfts: OmniSearchNftsReducer,
    featuredCollections: FeaturedCollectionsReducer
  });
